/** Shopify CDN: Minification failed

Line 43:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 44:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 44:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 45:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 45:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 47:46 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 57:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 61:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 61:23 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 62:12 Transforming const to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 29:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 30:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 30:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 31:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 31:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 33:46 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 43:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 47:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 47:23 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 48:12 Transforming const to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 15:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 16:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 16:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 17:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 17:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 19:46 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 29:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 33:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 33:23 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 34:12 Transforming const to the configured target environment ("es5") is not supported yet

**/
(async () => {
    const { Core } = await importModule('Core');
    const { $toggleDisplay } = await importModule('Utils');

    customElements.define('buy-with-counter', class extends Core {
        elements = {
            addOne: '[data-element="add-one"]',
            addMany: '[data-element="add-many"]'
        }
        
        subscriptions = {
            'buyWith:change':  '_updateCounter'
        }

        render() {
            this.subscribe('buyWith:change');
        }
        
        _updateCounter({ selected }) {
            const count = selected + 1;
            this.$addMany.querySelector('[data-i18n-amount]').textContent = count;
            $toggleDisplay(this.$addMany, count > 1)
            $toggleDisplay(this.$addOne, count <= 1)

        }
    })
})();